module.exports = __webpack_public_path__ + "static/media/psicologa.35025075.png";